import { render } from "./lines_left_blur.svg?vue&type=template&id=1c1fd90a"
const script = {}
script.render = render

export default script